import { useScreen } from "src/contexts/ScreenContext";

function useIsMobile() {

    const { isMobile } = useScreen()

    return isMobile;
}

export default useIsMobile;